import { PUBLIC_FEATURE_FLAGS_RECEIVED } from '../actions/constants/ActionTypes';
const initialState = [];
const PublicFeatureFlags = (state = initialState, {
  type,
  payload
}) => {
  switch (type) {
    case PUBLIC_FEATURE_FLAGS_RECEIVED:
      {
        const {
          activeFeatureFlags
        } = payload;
        return [...activeFeatureFlags];
      }
    default:
      return state;
  }
};
export default PublicFeatureFlags;